import { render, staticRenderFns } from "./WordTemplatesForm.vue?vue&type=template&id=4511da0b&"
import script from "./WordTemplatesForm.vue?vue&type=script&lang=js&"
export * from "./WordTemplatesForm.vue?vue&type=script&lang=js&"
import style0 from "./WordTemplatesForm.vue?vue&type=style&index=0&id=4511da0b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports